<template>
  <div class="animated fadeIn equipmentList bgV2">
    <div class="boxShadow heig-frame-tab clear-border-top mb-20 mt-25">
      <b-row>
        <b-col md="3">
          <div class="widgetV2 heig-frame-child">
            <div class="widget-header">
              <div class="title">Reference</div>
              <div class="action">
                <b-button  :disabled ="!$checkRole($accessModule.reference_table, 'delete')" @click="checkAllowDelete([])">
                  <div class="tooltip">Delete</div>
                  <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
                  </svg>
                </b-button>
                <b-button :disabled ="!$checkRole($accessModule.reference_table, 'create')" @click="openModalCreateGroup">
                  <div class="tooltip">Create</div>
                  <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                    <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                    <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                  </svg>
                </b-button>
                <b-button :disabled ="!$checkRole($accessModule.reference_table, 'update')" @click="editGroup">
                  <div class="tooltip">Edit</div>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.708 5.63151C21.098 6.02151 21.098 6.65151 20.708 7.04151L18.878 8.87151L15.128 5.12151L16.958 3.29151C17.1449 3.10426 17.3985 2.99902 17.663 2.99902C17.9276 2.99902 18.1812 3.10426 18.368 3.29151L20.708 5.63151ZM2.99805 20.5015V17.4615C2.99805 17.3215 3.04805 17.2015 3.14805 17.1015L14.058 6.19151L17.808 9.94151L6.88805 20.8515C6.79805 20.9515 6.66805 21.0015 6.53805 21.0015H3.49805C3.21805 21.0015 2.99805 20.7815 2.99805 20.5015Z" fill="#999999"/>
                  </svg>
                </b-button>
              </div>
            </div>
            <div class="contenAbsolute">
              <div class="tree-view-properties">
                <div class="position-relative custom-reference-tree" ><!-- v-bind:class="{'run-loading':loadings.group}" -->
                  <tree :data="groups" @node:selected="selectGroup" ref="treeViewGroup">
                    <div slot-scope="{ node }" class="node-container">{{ node.text }}</div>
                  </tree>
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col md="9" class="pl-0 border-table custom-reference-table">
          <gofix-table :settings="tableConfig"
                       :table-items="tableItems"
                       @load-items="getTableData"
                       @row-click="goToDetail"
                       @delete-items="deleteItems"
                       @new-item="openCreateItemModal"
                       ref="gofixTable">
          </gofix-table>
        </b-col>
      </b-row>
    </div>
    <b-modal :no-close-on-backdrop="true" id="modal-create-item" modal-class="modal-create" :title="modals.createItem.title" hide-footer :centered="true" v-model="modals.createItem.open">
      <div v-bind:class="{'run-loading':modals.createItem.loading}">
        <b-form class="pb-20">
          <b-row>
            <b-col md="12">
              <gofix-form-input label="Title" v-model="referenceItem.reference_type" disabled></gofix-form-input>
            </b-col>
            <b-col md="12">
              <gofix-form-input label="Value" v-model="referenceItem.reference_value_text"></gofix-form-input>
            </b-col>
          </b-row>
        </b-form>
        <b-button-group class="d-block text-right">
          <gofix-button :disabled="!$checkRole($accessModule.reference_table, 'update')" label="APPLY" @click="save" noBorder></gofix-button>
        </b-button-group>
      </div>
    </b-modal>
    <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="Remove SOR Group" hide-footer hide-header :centered="true" ref="modal-Remove" v-model="modals.deleteGroup.open">
      <div class="center">
        Are you sure you want to<br/>delete <strong>This Item</strong>?<br/>
      </div>
      <b-button-group class="btn-group">
        <b-button class="custom-btn" @click="modals.deleteGroup.open = false">No</b-button>
        <b-button class="custom-btn" @click="deleteGroup" :disabled="modals.deleteGroup.loading">
          <b-spinner v-if="modals.deleteGroup.loading" small type="grow"></b-spinner>
          Yes
        </b-button>
      </b-button-group>
    </b-modal>
    <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.createGroup.title" hide-footer :centered="true" v-model="modals.createGroup.open">
      <div v-bind:class="{'run-loading':modals.createGroup.loading}">
        <b-form class="pb-20">
          <b-row>
            <b-col md="12">
              <gofix-form-input label="Title" v-model="referenceType.reference_type"></gofix-form-input>
            </b-col>
          </b-row>
        </b-form>
        <b-button-group class="d-block text-right">
          <gofix-button :disabled="!$checkRole($accessModule.reference_table, 'create')" label="APPLY" @click="saveGroup('update')" noBorder></gofix-button>
        </b-button-group>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import LiquorTree from 'liquor-tree';

  import { filters } from '@/_filterVar.js'
  export default {
    name: 'sor',
    components: {
      [LiquorTree.name]: LiquorTree,
    },
    data () {
      let filter = JSON.parse(JSON.stringify(filters['reference']));

      return {
        tableConfig:{
          name: 'reference',
          controls:{
              create: this.$checkRole(this.$accessModule.reference_table, 'create'),
              delete: this.$checkRole(this.$accessModule.reference_table, 'delete')
          },
          filter: filter,
          page: 1,
          limit: 100,
          total: 0,
          useDatabaseView: true,
          sortColumn: "reference_value_text",
          sortDirection: "asc",
          itemSelected: [],
          fields: [
            {
              key: 'actions',
              label: '',
              thClass: 'checkbox-column text-center',
              tdClass: 'checkbox-column text-center',
              width: 50,
              thStyle: "width:50px",
            },
            {
              key: 'id',
              label: '#',
              placeholder: 'search',
              isActive: 1,
              isFilter: true,
              with:150,
              thStyle: "width:150px",
              sorting: true,
            },
            {
              key: 'reference_value_text',
              label: 'Title',
              placeholder: 'search',
              isActive: 1,
              isFilter: true,
              with:300,
              thStyle: "width:300px",
              sorting: true,
            }
          ]
        },
        tableItems: [],
        modals:{
          createGroup:{
            open: false,
            title: 'Create Reference table',
            loading: false,
            data: {
              id: null,
              parent_id: null,
              description_one: null
            }
          },
          deleteGroup : {
            open: false,
            loading: false,
            deleteItems: false
          },
          createItem:{
            open: false,
            title: 'Create Item',
            loading: false,
          }
        },
        activeClass: false,
        navActive: {
          name: 'SOR',
          active: 1
        },
        reloadTypePage: null,
        nodeSelected: null,
        contractTerms: null,
        groupSelect: null,
        groups: this.getData(),
        groupsTemp: [],
        rootId: 0,
        loadings:{
          group: false,
          service: true,
        },
        referenceItem:{
          id:null,
          reference_type:null,
          reference_value_text: null,
        },
        referenceType:{
          id:null,
          reference_type:null
        },
      }
    },
    created () {
      //this.reloadGroup()
    },
    computed: {
      ...mapGetters({
        UserLogin: "AuthController/user",
        ClientContractID: 'ContractController/ClientContractID',
      })
    },
    watch: {
    },
    methods:{
      /*--- Table event-------------------------------*/
      async getTableData(callback){
        const { tableRequest , resolve,reject } = await callback();
        //  if(tableRequest.filter && tableRequest.filter.reference_type && this.nodeSelected){
        //   tableRequest.filter.reference_type.value = this.nodeSelected.id;
        // }else{
        //   tableRequest.filter.reference_type.value = null;
        // }
        if(tableRequest.filter.reference_type.value) {
          await this.$store.dispatch("ReferenceController/getItems", tableRequest)
                .then(response => {
                  this.tableItems = response.items;
                  this.tableConfig.total = response.total;
                  resolve(response);
                })
                .catch(err => {
                  this.$bvToast.toast("Can not load the References", {
                    title: `Notification`,
                    autoHideDelay: 3000,
                    variant: 'danger',
                    solid: true
                  })
                  reject();
                })
        }
        
      },
      async deleteItems(callback){
        try {
          const { ids,filter, resolve,reject } = await callback();
          let result = await this.checkAllowDelete(ids);
          if(!result) {
            resolve();
            return 
          }
          
          await this.$store.dispatch("ReferenceController/deleteItem", ids)
                  .then(response => {
                    resolve(this.$notificationV2('deleting', 'reference'));
                  })
                  .catch(err =>{
                    reject(err);
                  });
        } catch (error) {
          reject(err);
        }
      },
      goToDetail(item){
        this.referenceItem.id                     = item.id
        this.referenceItem.reference_type         = item.reference_type
        this.referenceItem.reference_value_text   = item.reference_value_text
        this.modals.createItem.title = 'Edit Item'
        this.modals.createItem.open = true
      },
      openCreateItemModal(){
        this.referenceItem.id       = 0
        //this.referenceItem.reference_type         = null
        this.referenceItem.reference_value_text   = null
        this.modals.createItem.title = 'Create Item'
        this.modals.createItem.open = true
      },
      save(){
        if (!this.referenceItem.reference_type || !this.referenceItem.reference_value_text) {
            return this.$bvToast.toast('Reference is a required field.', {
                title: `Notification`,
                autoHideDelay: 3000,
                variant: 'danger',
                solid: true
            })
        }
        let request = {
          reference_type:         this.referenceItem.reference_type,
          reference_value_text:   this.referenceItem.reference_value_text,
        }
        let method    = 'createItem';
        let keyMessage= 'adding'

        if(this.referenceItem.id != "0") {
          request.id        = this.referenceItem.id;
          method            = 'updateItem';
          keyMessage = 'editing'
        }
        this.$store.dispatch(`ReferenceController/${method}`, request)
        .then(result => {
            this.$bvToast.toast( this.$notificationV2(keyMessage, 'reference'), {
                title: `Notification`,
                autoHideDelay: 3000,
                variant: 'success',
                solid: true
            })
            this.modals.createItem.open = false
            this.$refs['gofixTable'].reloadTableKeepFilter();
        })
        .catch(error => {
            if(error.response && error.response.data.error.message.error) {
                return this.$bvToast.toast(error.response.data.error.message.error, {
                    title: `Notification`,
                    autoHideDelay: 3000,
                    variant: 'danger',
                    solid: true
                });
            }
        })
      },
      /*----------------------------------*/

      /*-- Group event --------------------------------*/
      getData() {
          return new Promise((resolve, reject) => {
            global
              .axios(`api/references/type`, {
                method: "GET",
                headers: {
                  Accept: "application/json"
                }
              })
              .then(response => {
                this.loadings.group = false;
                response.data.data.forEach(item => {
                  item.data = Object.assign({}, item);
                })
                if(response.data.data.length > 0){
                  response.data.data[0].state = {selected: true}
                  this.tableConfig.filter.reference_type.value = response.data.data[0].id;
                  this.reloadTypePage = response.data.data[0].id;
                  //console.log(this.tableConfig)
                  this.$refs['gofixTable'].reloadTableItems();
                }
                this.groupsTemp = !response.data.data ? [] : response.data.data;
                resolve(response.data.data);
              })
              .catch(error => {
                this.loadings.group = false;
                reject(error);
              });
          });
        },
      selectGroup(node){
        this.nodeSelected = node;
        //this.modals.createGroup.data.parent_id = node.id;
        this.referenceItem.reference_type         = node.id
        this.tableConfig.filter.reference_type.value = node.id;
        this.$refs.gofixTable.reloadTableItems();
      },
      deleteGroup(){
        if(!this.nodeSelected) return;
        this.modals.deleteGroup.loading = true;
        this.saveGroup('delete');
        this.tableConfig.filter.reference_type.value = this.reloadTypePage;
        this.$refs.gofixTable.reloadTableItems();
      },
      saveGroup(status){
        let reference_value_text = this.groupsTemp.slice();

        if(status === 'update') {
          if(this.referenceType.id) {
            if (!this.referenceType.reference_type) {
              return this.$bvToast.toast('Reference is a required field.', {
                  title: `Notification`,
                  autoHideDelay: 3000,
                  variant: 'danger',
                  solid: true
              })
            }
            reference_value_text = reference_value_text.map(item => {
              if(item.id == this.referenceType.id) {
                item.text = this.referenceType.reference_type;
              }
              return item;
            })
          }
          else {
            if (!this.referenceType.reference_type) {
              return this.$bvToast.toast('Reference is a required field.', {
                  title: `Notification`,
                  autoHideDelay: 3000,
                  variant: 'danger',
                  solid: true
              })
            }
            reference_value_text.push({
              id: this.referenceType.reference_type,
              text: this.referenceType.reference_type
            })
          }
        }

        if(status === 'delete') {
          if(this.nodeSelected) {
            reference_value_text = reference_value_text.filter(item => item.id != this.nodeSelected.id)
          }
        }

        reference_value_text = JSON.stringify(reference_value_text)

        let request = {
          reference_type:         'Reference',
          reference_value_text:   reference_value_text,
        }

        this.$store.dispatch('ReferenceController/createItem', request)
        .then(result => {
            this.$bvToast.toast( this.$notificationV2('editing', 'reference'), {
                title: `Notification`,
                autoHideDelay: 3000,
                variant: 'success',
                solid: true
            })
            this.modals.createGroup.open = false
            this.modals.deleteGroup.loading = false;
            this.modals.deleteGroup.open = false;
            this.groupsTemp = JSON.parse(request.reference_value_text);
            this.$set(this.$refs.treeViewGroup, 'model', JSON.parse(request.reference_value_text));
            this.$refs.treeViewGroup.tree.setModel(JSON.parse(request.reference_value_text));
            this.$refs['gofixTable'].reloadTableKeepFilter();
        })
      },
      editGroup(){
        if(!this.nodeSelected){
          this.$bvToast.toast("Please select a group to edit", {
            title: `Notification`,
            autoHideDelay: 3000,
            variant: 'danger',
            solid: true
          });
        }else{
          this.modals.createGroup.title = 'Edit Reference Table';
          this.referenceType.id = this.nodeSelected.id;
          this.referenceType.reference_type = this.nodeSelected.data.text;
          this.modals.createGroup.open = true;
        }
      },
      openModalCreateGroup() {
        this.referenceItem.id = 0
        this.referenceType.id = 0;
        this.referenceType.reference_type = '';
        this.modals.createGroup.open = true;
        this.modals.createGroup.title = 'Create Reference Table';
      },
      async checkAllowDelete(ids = []) {
        try {
          let params = {
            reference_type: this.nodeSelected.data.text
          }
          if(ids) params.ids = ids;
          await this.$store.dispatch('ReferenceController/checkDeleteReference', params)
          if(!ids.length) {
            this.modals.deleteGroup.open = await true;
          }
          return true;
        } catch (error) {
            this.$alertNotification('Deletion is allowed only if there is no user associated with the project.', "danger");
            return false;
        }
      },
      /*----------------------------------*/

    }
  }
</script>
